import { render } from "./InvoiceModal.vue?vue&type=template&id=5d503497"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/components/InvoiceModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d503497"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d503497', __exports__)) {
    api.reload('5d503497', __exports__)
  }
  
  module.hot.accept("./InvoiceModal.vue?vue&type=template&id=5d503497", () => {
    api.rerender('5d503497', render)
  })

}


export default __exports__